import { render, staticRenderFns } from "./LearningWizard.vue?vue&type=template&id=6cfe9ac5&scoped=true"
import script from "./LearningWizard.vue?vue&type=script&lang=js"
export * from "./LearningWizard.vue?vue&type=script&lang=js"
import style0 from "./LearningWizard.vue?vue&type=style&index=0&id=6cfe9ac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe9ac5",
  null
  
)

export default component.exports